import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import mainHelper from "../../helpers/MainHelper";

class StockAlertsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleMarkAsRead = async (alertId) => {
        try {
            const response = await apiCall(`business/stock/alert/mark-read/${alertId}`,'post');
            mainHelper.toastMessage(response.status, response.message);
            if(response.status === 'success') {
                this.triggerFetch();
            }
        } catch (e) {
            console.error(e);
        }
    }

    getAlertTypeLabel = (type) => {
        const types = {
            'low_stock': 'Düşük Stok',
            'out_of_stock': 'Stok Tükendi',
            'expiring_soon': 'SKT Yaklaşıyor',
            'expired': 'SKT Geçti'
        };
        return types[type] || type;
    }

    getAlertTypeBadge = (type) => {
        const badges = {
            'low_stock': 'badge-warning',
            'out_of_stock': 'badge-danger',
            'expiring_soon': 'badge-info',
            'expired': 'badge-dark'
        };
        return badges[type] || 'badge-secondary';
    }

    render() {
        const columns = [
            {
                name:'Durum',
                cell: row => (
                    row.is_read ? 
                        <i className="icon-check text-success" style={{fontSize: '20px'}}></i> :
                        <i className="icon-info text-warning" style={{fontSize: '20px'}}></i>
                ),
                minWidth: '90px',
                maxWidth: '110px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Uyarı Tipi',
                cell: row => (
                    <span className={`badge ${this.getAlertTypeBadge(row.alert_type)}`} style={{
                        fontSize: '11px',
                        padding: '8px 14px',
                        fontWeight: '600',
                        minWidth: '100px',
                        display: 'inline-block',
                        textAlign: 'center'
                    }}>
                        {this.getAlertTypeLabel(row.alert_type)}
                    </span>
                ),
                sortable:true,
                minWidth: '150px',
                maxWidth: '170px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Depo',
                selector:row => row.warehouse ? row.warehouse.name : '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Stok Kalemi',
                selector:row => row.stock_item ? row.stock_item.name : '-',
                sortable:true,
                grow: 1.5,
                wrap: true,
                style: {
                    padding: '12px 8px',
                    fontWeight: '500'
                }
            },
            {
                name:'Mesaj',
                selector:row => row.message,
                sortable:true,
                grow: 2,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Tarih',
                selector:row => new Date(row.created_at).toLocaleString('tr-TR'),
                sortable:true,
                minWidth: '170px',
                maxWidth: '190px',
                style: {
                    padding: '12px 8px',
                    fontSize: '13px'
                }
            },
            {
                name: 'İşlem',
                button: true,
                minWidth: '100px',
                maxWidth: '120px',
                center: true,
                cell: row => (
                    <>
                        {!row.is_read && (
                            <IconButton 
                                className="btn btn-outline-success btn-sm"
                                onClick={() => this.handleMarkAsRead(row.id)}
                                title="Okundu İşaretle"
                                style={{padding: '8px 14px'}}>
                                <i className="icon-check" style={{fontSize: '16px'}}></i>
                            </IconButton>
                        )}
                    </>
                ),
                style: {
                    padding: '8px'
                }
            },
        ];

        return (
            <DataTable
                ref={this.tableRef}
                columns={columns}
                dataEndpoint="business/stock/alert/all"
            />
        );
    }
}

export default withPermissions(withRouter(StockAlertsTable));

